import ButtonLink from './button-link';
import './button-link.scss';

export default ButtonLink;
